import React, { useEffect, useState } from 'react';
import animateScrollTo from 'animated-scroll-to';
// import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
// import Banner from '../../common/Banner/Banner';
// import Button from '../../common/button/Button';

// const firstBannerConfig = {
//     title: 'CONTINUE DEPOIS DA PUBLICIDADE',
//     class: 'col-11',
//     adUnit: 'a1nova-tv-first_multi_sizes',
//     sizes: [[970, 250], [970, 90], [728, 90], [320, 50], [300, 100], [234, 60]],
//     sizeMapping: [
//         { viewport: [1250, 0], sizes: [[970, 250], [970, 90], [728, 90]] },
//         { viewport: [991, 0], sizes: [[728, 90], [320, 50], [300, 100]] },
//         { viewport: [365, 0], sizes: [[320, 50], [300, 100]] },
//         { viewport: [0, 0], sizes: [[234, 60]] },
//     ],
//     shouldRefresh: true,
// };

// const secondBannerConfig = {
//     title: 'CONTINUE DEPOIS DA PUBLICIDADE',
//     class: 'col-11',
//     adUnit: 'a1nova-tv-second_multi_sizes',
//     sizes: [[970, 250], [970, 90], [728, 90], [320, 50], [300, 100]],
//     sizeMapping: [
//         { viewport: [1250, 0], sizes: [[970, 250], [970, 90], [728, 90]] },
//         { viewport: [991, 0], sizes: [[728, 90], [320, 50], [300, 100]] },
//         // Note: Mauricio asked to not show the second banner on mobiles...
//     ],
//     shouldRefresh: true,
// };


const TvComponent = () => {
    const [selectedPlayer, setSelectedPlayer] = useState(false);

    const HandleLetra = () => {
        if (selectedPlayer === false) {
            // eslint-disable-next-line no-const-assign
            setSelectedPlayer(true);
        }
    };

    const HandleClipe = () => {
        if (selectedPlayer === true) {
            // eslint-disable-next-line no-const-assign
            setSelectedPlayer(false);
        }
    };

    // const isSmall = breakpoint.isSmall;

    useEffect(() => {
        animateScrollTo(0, { speed: 700 });
    }, []);


    return (
        <section className="sectionTv">
            <header>
                <h1>Antena 1 TV</h1>
                <p className="player-text-top">Assista ao stream de video ao vivo da Antena 1!</p>
            </header>


            {/* <Banner key={firstBannerConfig.adUnit} config={firstBannerConfig} /> */}
            <div className="small-screen">
                <div className="change-player">
                    <button type="button" className={selectedPlayer === false ? 'player-btn-selected' : 'player-btn'} onClick={HandleClipe}>
                        Antena1 TV
                    </button>
                    <button type="button" className={selectedPlayer === true ? 'player-btn-selected' : 'player-btn'} onClick={HandleLetra}>
                        Letra e Tradução
                    </button>
                </div>
                <div className="player">
                    <div className="containerTv">
                        <div className="embedContainer">
                            <iframe
                                allowFullScreen
                                src={selectedPlayer === false ? 'https://www.dailymotion.com/embed/video/x8naz0t?autoplay=1' : 'https://www.dailymotion.com/embed/video/x8rzf57?autoplay=1'}
                                title="0"
                                width="100%"
                                height="650"
                                frameBorder="0"
                                className="video"
                            />
                        </div>
                    </div>
                </div>
                {/* <Button className="videosBtn" title="Veja mais videos" to="/videos">Veja mais vídeos</Button> */}
            </div>
            {/* {!isSmall && <Banner key={secondBannerConfig.adUnit} config={secondBannerConfig} />} */}

        </section>
    );
};

export default TvComponent;

TvComponent.propTypes = exact({
    // breakpoint: PropTypes.object, // Immutable list!
});
